import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ComisionesdevendedoresRoutingModule } from './comisionesdevendedores-routing.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';

// Material Modules
import { MatTableModule } from '@angular/material/table';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatSelectModule } from '@angular/material/select';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatIconModule } from '@angular/material/icon';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatCardModule } from '@angular/material/card';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSortModule } from '@angular/material/sort';

// Feature Modules
import { CitafuturaModule } from './modules/citafutura/citafutura.module';
import { BonificacionesextrasModule } from './modules/bonificacionesextras/bonificacionesextras.module';
import { NovedadescomercialesModule } from './modules/novedadescomerciales/novedadescomerciales.module';
import { TipodenovedadesModule } from './modules/tipodenovedades/tipodenovedades.module';
import { ConceptocomisionesModule } from './modules/conceptocomisiones/conceptocomisiones.module';
import { MetavendedorModule } from './modules/metavendedor/metavendedor.module';
import { AgrupacionnovedadesModule } from './modules/agrupacionnovedades/agrupacionnovedades.module';
import { AjustedevaloresModule } from './modules/ajustedevalores/ajustedevalores.module';
import { SincronizacionSapModule } from './modules/sincronizacionsap/sincronizacionsap.module';
import { GarantizadosModule } from './modules/garantizados/garantizados.module';
const materialModules = [
  MatTableModule,
  MatPaginatorModule,
  MatFormFieldModule,
  MatInputModule,
  MatButtonModule,
  MatSelectModule,
  MatCheckboxModule,
  MatAutocompleteModule,
  MatIconModule,
  MatSnackBarModule,
  MatCardModule,
  MatProgressSpinnerModule,
  MatSortModule
];

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    ComisionesdevendedoresRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    ...materialModules,
    CitafuturaModule,
    BonificacionesextrasModule,
    NovedadescomercialesModule,
    TipodenovedadesModule,
    ConceptocomisionesModule,
    MetavendedorModule,
    AgrupacionnovedadesModule,
    AjustedevaloresModule,
    SincronizacionSapModule,
    GarantizadosModule
  ]
})
export class ComisionesdevendedoresModule { }
